import { Alert } from '@designsforhealth/dfh-react-components'
import { CircularProgress, DialogContent } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'

import ErrorUpdatingCartMessage from '../../../ErrorUpdatingCartMessage'
import {
  Modal,
  ModalActionButton,
  ModalCloseButton,
  ModalCloseIcon,
  ModalHeader,
  ModalTitle,
} from './styled'

export interface ShippingRestrictionsModalProps {
  className?: string
  handleClose(): void
  handleContinue(): void
  handleRemoveItems(): void
  loading: boolean
  open: boolean
  removeItemsError: unknown
  region?: string
}

export const ShippingRestrictionsModal: React.FC<ShippingRestrictionsModalProps> = ({
  className,
  children,
  handleClose,
  handleContinue,
  handleRemoveItems,
  loading,
  open,
  removeItemsError,
}) => {
  return (
    <Modal
      aria-describedby="scroll-dialog-description"
      aria-labelledby="scroll-dialog-title"
      className={className}
      fullWidth
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      <ModalTitle disableTypography id="scroll-dialog-title">
        <ModalHeader>SHIPPING RESTRICTIONS</ModalHeader>
        <ModalCloseIcon aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </ModalCloseIcon>
      </ModalTitle>
      <DialogContent dividers>
        {children}
        {removeItemsError && (
          <Alert type="error">
            <ErrorUpdatingCartMessage />
          </Alert>
        )}
        <ModalActionButton onClick={handleRemoveItems} disabled={loading}>
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'REMOVE CONFLICTING ITEM(S) FROM CART'
          )}
        </ModalActionButton>
        <ModalCloseButton color="secondary" onClick={handleContinue} variant="outlined">
          CHANGE SHIPPING ADDRESS
        </ModalCloseButton>
      </DialogContent>
    </Modal>
  )
}
